import { render } from "./TheDialogInformations.vue?vue&type=template&id=48b64a20&scoped=true&ts=true"
import script from "./TheDialogInformations.vue?vue&type=script&lang=ts"
export * from "./TheDialogInformations.vue?vue&type=script&lang=ts"

import "./TheDialogInformations.vue?vue&type=style&index=0&id=48b64a20&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src317777935/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b64a20"]])

export default __exports__